import React from "react";

import logo from '../htdocs/images/logo.png'

function Logo () {
    return (
        <div className="brand-logo">
            <img src={logo} alt="logo" />
        </div>
    );
}

export { Logo }